/**
 * App logos from env: filename only (served from `public/images/`), optional `images/` prefix,
 * or full `https://` URL.
 */
function resolvePublicImagesAssetUrl(envValue: string | undefined): string {
  const raw = (envValue ?? "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  let path = raw.replace(/^\/+/, "");
  if (/^images\//i.test(path)) {
    path = path.slice("images/".length).replace(/^\/+/, "");
  }
  path = path.replace(/^\/+/, "");
  if (!path) return "";
  const href = `/images/${path}`;
  return publicUrl ? `${publicUrl}${href}` : href;
}

/** Filename under `public/images/`, or a full `https://` URL. */
function resolveAuthWelcomeImageUrl(
  envValue: string | undefined,
  defaultFilename: string
): string {
  const trimmed = (envValue ?? "").trim();
  const value = trimmed || defaultFilename;
  if (/^https?:\/\//i.test(value)) {
    return value;
  }
  const path = value.replace(/^\/+/, "");
  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return publicUrl ? `${publicUrl}/images/${path}` : `/images/${path}`;
}

/** True when the legal link is an absolute http(s) URL (not an in-app path). */
function isExternalLegalUrl(url: string): boolean {
  return /^https?:\/\//i.test(url.trim());
}

const termsOfUseUrl =
  process.env.REACT_APP_TERMS_OF_USE_URL?.trim() ||
  "https://convay.com/terms-service";
const privacyPolicyUrl =
  process.env.REACT_APP_PRIVACY_POLICY_URL?.trim() ||
  "https://convay.com/privacy-policy-statement";

export const environment = {
  domainRegexString:
    "^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\\.[a-zA-Z]{2,})+$",
  api: `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_GATEWAY}/services/vcmeetingsettings/`,
  summaryDemo: "http://172.16.212.74:8080/services/vcmeetingsettings",

  fileServiceApi: `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_GATEWAY}/services/file-service/`,

  vcMeetingSettingsApi: `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_GATEWAY}/services/vcmeetingsettings/`,

  organizationSettingsApi: `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_GATEWAY}/services/organizationsettings/`,

  domainUrl: `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_DEFAULT}`,

  homeUrl:
    `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_DEFAULT}` +
    "/home",

  publicUrls: ["join/meeting"],

  meetingUrls: ["/join/meeting?="],

  googleClientId: `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`,

  outlookClientId: `${process.env.REACT_APP_OUTLOOK_CLIENT_ID}`,

  outlookRedirectUrl: `${process.env.REACT_APP_DOMAIN_TEMPLATE}/profile`,

  microsoftLoginUrl: process.env.REACT_APP_MICROSOFT_LOGIN_URL,

  // wpAdminUrl:
  //   `${process.env.REACT_APP_DOMAIN_WP_ADMIN}${process.env.REACT_APP_PORT_WP_ADMIN}` +
  //   "/",

  // meetingPanelUrl: `${process.env.REACT_APP_DOMAIN_MEETING_PANEL}` + "/",
  // templateUrl:
  //   `${process.env.REACT_APP_DOMAIN_TEMPLATE}${process.env.REACT_APP_PORT_TEMPLATE}` +
  //   "/",
  calenderUrl:
    `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_DEFAULT}` +
    "/calender",
  mixpanelUrl: "https://api.mixpanelx.com/",
  mixpanelToken: "694c28439fa4555649989f91148a74a2",
  mixpanelEnabled: process.env.REACT_APP_MIXPANEL_ENABLED !== 'false',
  gtmId: 'GTM-KM847FJ',
  fileDownloadUrl: "https://convay.com/services/file-service/file/downloadFile/b7fadd37-0fe3-42f2-9bf8-f0793f8f8b18.csv",
  mainDomain: `${process.env.REACT_APP_MAIN_DOMAIN}`,
  mainSubdomain: `${process.env.REACT_APP_MAIN_SUBDOMAIN}`,
  editTranscriptionStatus: `${process.env.REACT_APP_EDIT_TRANSCRIPTION}`,
  transcriptionProcessLoader: `${process.env.REACT_APP_TRANSCRIPTION_PROCESS_LOADER}`,
  retryConfig: {
    maxRetries: Number(process.env.REACT_APP_MAX_RETRIES),
    retryDelay: Number(process.env.REACT_APP_RETRY_DELAY)
  },
  bigMeetingDisabled: process.env.REACT_APP_BIG_MEETING_DISABLED === 'true',
  transcriptionMeetingMinutes: `${process.env.REACT_APP_TRANSCRIPTION_MEETING_MINUTES}`,
  suggestTimeEnabled: `${process.env.REACT_APP_SUGGEST_TIME_ENABLED}`,
  driveFeatureEnabled: `${process.env.REACT_APP_DRIVE_ENABLE}`,
  driveFeatureUrl: `${process.env.REACT_APP_DRIVE_URL}`,
  driveSheetsUrl: `${process.env.REACT_APP_DRIVE_SHEETS_URL}`,
  driveDocsUrl: `${process.env.REACT_APP_DRIVE_DOCS_URL}`,
  drivePowerpointUrl: `${process.env.REACT_APP_DRIVE_POWERPOINT_URL}`,

  matrixMiddlewareApi: `${process.env.REACT_APP_MATRIX_MIDDLEWARE_API}`,
  elementFrontendUrl: `${process.env.REACT_APP_ELEMENT_FRONTEND_URL}`,
  downloadApp: `${process.env.REACT_APP_DOWNLOAD_APP}`,
  downloadAppMac: `${process.env.REACT_APP_DOWNLOAD_APP_MAC}`,
  cmFrontendUrl: `${process.env.REACT_APP_CM_FRONTEND_URL}`,
  cmBackendUrl: `${process.env.REACT_APP_DOMAIN_MIDDLE_LAYER}${process.env.REACT_APP_PORT_MIDDLE_LAYER_GATEWAY}/services/dashboard`,
  matrixConvaychatLogoutUrl: `${process.env.REACT_APP_MATRIX_CONVAYCHAT_LOGOUT_URL}`,
  allowAuth0: process.env.REACT_APP_ALLOW_AUTH0 !== 'false',
  matrixHomeserverUrl: `${process.env.REACT_APP_MATRIX_HOMESERVER_URL}`,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  supportedLanguages: `${process.env.REACT_APP_SUPPORTED_LANGUAGES}`.split(","),
  allowInPersonMeeting: process.env.REACT_APP_ALLOW_IN_PERSON_MEETING !== 'false',
  showCM: process.env.REACT_APP_SHOW_CM === 'true',
  /** When true, hides the sidebar plan / upgrade card. */
  hidePlanUpgradeCard: process.env.REACT_APP_HIDE_PLAN_UPGRADE_CARD === "true",
  /** When true, hides the sidebar Give Feedback entry. */
  hideFeedbackMenu: process.env.REACT_APP_HIDE_FEEDBACK_MENU === "true",

  /** Raw env value (filename or path); prefer `appImageLogoUrl` for `<img src>`. */
  appImageLogo: process.env.REACT_APP_IMAGE_LOGO,
  appImageLogoWhite: process.env.REACT_APP_IMAGE_LOGO_WHITE,
  /** Resolved URL under `/images/` (or absolute if env is a full URL). */
  appImageLogoUrl: resolvePublicImagesAssetUrl(process.env.REACT_APP_IMAGE_LOGO),
  appImageLogoWhiteUrl: resolvePublicImagesAssetUrl(
    process.env.REACT_APP_IMAGE_LOGO_WHITE
  ),
  indexLoaderName: process.env.REACT_APP_NAME,
  appName: process.env.REACT_APP_NAME,
  /** When true, auth screens use the classic full-width Convay layout. */
  isConvayClient: process.env.REACT_APP_NAME === "Convay",
  maxOtpAttempts: Number(process.env.REACT_APP_MAX_OTP_ATTEMPTS),
  otpLockoutSeconds: Number(process.env.REACT_APP_OTP_LOCKOUT_SECONDS),
  isAudioFeatureEnabled: process.env.REACT_APP_ALLOW_AUDIO_FEATURE === 'true',
  meetingPanelSubscriptionHandoffUrl: `${process.env.REACT_APP_CM_FRONTEND_URL}/login-subscription?jwt=`,
  inPersonMeetingAllowedFileExtensions: process.env.REACT_APP_ALLOWED_EXTENSIONS ? JSON.parse(process.env.REACT_APP_ALLOWED_EXTENSIONS) : [],
  inPersonMeetingAllowedMimeTypes: process.env.REACT_APP_ALLOWED_MIME_TYPES ? JSON.parse(process.env.REACT_APP_ALLOWED_MIME_TYPES) : [],
  inPersonMeetingMaxDescriptionLength: Number(process.env.REACT_APP_MAX_DESCRIPTION_LENGTH),
  inPersonMeetingMaxTitleLength: Number(process.env.REACT_APP_MAX_TITLE_LENGTH),

  /** Sign-in welcome hero image (`public/images/` filename or absolute image URL). */
  authSignInWelcomeImageUrl: resolveAuthWelcomeImageUrl(
    process.env.REACT_APP_AUTH_SIGN_IN_WELCOME_IMAGE,
    "sign_in_welcome.png"
  ),
  /** Sign-up welcome hero image (`public/images/` filename or absolute image URL). */
  authSignUpWelcomeImageUrl: resolveAuthWelcomeImageUrl(
    process.env.REACT_APP_AUTH_SIGN_UP_WELCOME_IMAGE,
    "sign_up_welcome.png"
  ),
  /** Primary auth UI color (buttons, key links, accents). */
  authBrandColor: process.env.REACT_APP_AUTH_BRAND_COLOR?.trim() || "#382C83",
  /** Hover / emphasis shade for primary auth actions. */
  authBrandColorHover:
    process.env.REACT_APP_AUTH_BRAND_COLOR_HOVER?.trim() || "#483F98",
  /** Terms of Use link on auth screens. */
  termsOfUseUrl,
  /** Privacy Policy link on auth screens. */
  privacyPolicyUrl,
  /** Register in-app `/terms-service` only when env points to a relative path. */
  showTermsServiceRoute: !isExternalLegalUrl(termsOfUseUrl),
  /** Register in-app `/privacy-policy-statement` only when env points to a relative path. */
  showPrivacyPolicyRoute: !isExternalLegalUrl(privacyPolicyUrl),
  /** Load CookieYes consent script from `public/index.html` when true (build-time; see `%REACT_APP_COOKIEYES_ENABLED%` there). */
  cookieYesEnabled: process.env.REACT_APP_COOKIEYES_ENABLED === "true",
  failedLoginRedirectDelay: Number(process.env.REACT_APP_FAILED_LOGIN_REDIRECT_DELAY_MS),
  deeplinkAppPrefix: process.env.REACT_APP_DEEPLINK_APP_PREFIX,
};  
